import { Flex, Table, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import { OrderCategory } from "models/order_category";
import useNewProduct from "views/admin/config/newproduct/hooks/useNewProduct";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import OrderProductItem from "./OrderProductItem";

interface IOrderProductTable {
  categ: OrderCategory;
  borderColor: string;
}

const OrderProductItemTable = ({ categ, borderColor }: IOrderProductTable) => {
  const { unidades } = useMeasureUnit();

  const { list } = useNewProduct();

  return (
    <Table variant="striped" color="gray.500" mb="24px" mt="16px">
      <Thead>
        <Tr>
          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #ITEM
            </Flex>
          </Th>
          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #CÓDIGO_SKU
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #UNIDADE
            </Flex>
          </Th>
          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #QTD
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #VALOR UN
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #TOTAL
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {categ.OrcamentoProduto?.map((item) => (
          <OrderProductItem
            key={item.novoProdutoId}
            item={item}
            produtos={list}
            categ={categ}
          />
        ))}
      </Tbody>
    </Table>
  );
};
export default OrderProductItemTable;
